import axios from 'axios';

export default function exchangeShopData(data) {
  return axios.post(
    `${process.env.REACT_APP_BACKEND_BASE_URL}/api/security/decode`,
    data
  );
}



// WEBPACK FOOTER //
// ./src/utils/exchangeShopData.js